import React from 'react';
import PropTypes from 'prop-types';
import { searchInputText } from '../actions';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';

function SearchInput({ searchInputText }) {
    return (
        <TextField
            fullWidth
            hintText="Name..."
            floatingLabelText="Search:"
            onChange={(ev, newValue) => searchInputText(newValue)}
        />
    );
}

SearchInput.propTypes = {
    // From connect
    searchInputText: PropTypes.func.isRequired
};

export default connect(
    null,
    { searchInputText }
)(SearchInput);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/SearchInput.js
 **/